<template lang="html">
  <article class="office-presentation">
    <img :src="image" />
    <div class="office-presentation__infos">
      <h2 class="office-presentation__infos--title">{{ city }}</h2>
      <a
        target="_blank"
        :href="`http://maps.google.com/maps?q=${encodeURIComponent(address)}+${encodeURIComponent(
          country
        )}`"
      >
        <p class="office-presentation__infos--address">{{ address }}, {{ country }}</p>
      </a>
      <p class="office-presentation__infos--telephone">{{ telphone }}</p>

      <div class="office-presentation__infos__social">
        <ul>
          <li v-for="social in socials" :key="social.name" v-if="social.link">
            <a :href="social.link" v-if="social.link" target="_blank"> {{ social.name }} </a>
          </li>
        </ul>
      </div>
    </div>
  </article>
</template>

<script lang="js">
  export default  {
    name: 'office-presentation',
    props: {
      country: {
        type: String,
      },
      image: {
        type: String,
      },
      city: {
        type: String,
        required: true,
      },
      address: {
        type: String,
      },
      telphone: {
        type: String,
      },
      socials: {
        type: Array,
      }
    },
    mounted () {

    },

    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
.office-presentation {
  img {
    width: 100%;
  }

  &__infos {
    color: white;
    max-width: 320px;
    font-size: 20px;
    font-weight: 300;

    &--title {
      margin: 20px 0 30px;
      position: relative;
      font-weight: 300;
      font-size: 28px;
      color: white;
      font-family: $david;
    }

    &--address {
      color: white;
      max-width: 240px;
    }

    &--telephone {
      margin: 0;
      color: white;
    }

    &__social {
      margin-top: 10px;

      ul {
        margin: 0;
        padding: 0;
        display: flex;

        li {
          list-style: none;
          margin-right: 10px;
          font-size: 13px;
          color: white;
          text-transform: uppercase;

          a {
            color: white;
            transition: all 0.2s ease-in-out;

            &:hover {
              color: rgba(255, 255, 255, 0.5);
              transition: all 0.2s ease-in-out;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1400px) {
  .office-presentation {
    &__infos {
      font-size: 20px;

      &--title {
        font-size: 22px;
      }

      &__social {
        ul {
          li {
            font-size: 13px;
            margin-right: 15px;
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .office-presentation {
    &__infos {
      font-size: 17px;

      &--title {
        font-size: 17px;
      }

      &__social {
        ul {
          li {
            font-size: 12px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .office-presentation {
    margin-bottom: 50px;

    &__infos {
      font-size: 15px;

      &--title {
        margin: 10px 0;
      }

      &--telephone {
        margin-bottom: 20px;
      }

      &__social {
        ul {
          flex-flow: wrap;

          li {
            flex: 0 0 33%;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
